export default "__VITE_ASSET__C9zTFbP0__"